// Captured at module load — before React Router's "/" → "/he" <Navigate replace>
// strips the query string. Import this module at the very top of src/index.js.
const landingSearch = window.location.search;
const landingPath = window.location.pathname + landingSearch;

export function getLandingContext() {
    const params = new URLSearchParams(landingSearch);
    const utm = (key) => params.get(key) || null;

    return {
        utm_source: utm("utm_source"),
        utm_medium: utm("utm_medium"),
        utm_campaign: utm("utm_campaign"),
        utm_content: utm("utm_content"),
        utm_term: utm("utm_term"),
        referrer: document.referrer || null,
        landing_path: landingPath || null,
    };
}
